<template lang='pug'>
//- SideEffect-Post
div(:class='$style[`cc-side-effect-userPost`]')
  div(v-if='preloading' :class='$style[`cc-side-effect-userPost-preload`]')
    IconLoading(:size='30' :color='`#b1b1b1`')

  div(v-else :class='$style[`cc-side-effect-userPost-wrap`]')
    header.font-medium(:class='$style[`cc-side-effect-userPost-title`]')
      != '建立副作用記錄'
      span(:class='$style[`cc-side-effect-userPost-title-tips`]') 為必填

    section(:class='$style[`cc-side-effect-userPost-sec`]')
      div(:class='$style[`cc-side-effect-userPost-sec-notice`]')
        ul(:class='$style[`cc-side-effect-userPost-sec-notice-ul`]')
          //- li(:class='$style[`cc-side-effect-userPost-sec-notice-li`]') * 完成記錄後，系統會評比嚴重度並提供改善建議，請確實填寫。
          li(:class='$style[`cc-side-effect-userPost-sec-notice-li`]') * 每週至少記錄2次，每次記錄可累積C幣。
          //- li(:class='$style[`cc-side-effect-userPost-sec-notice-li`]') * 建議每週至少記錄2次，升級成為VIP會員可享「x2倍」C幣加成。
        button.font-medium(
          tabindex='0' aria-label='C幣是什麼？'
          :class='$style[`cc-side-effect-userPost-coin`]'
          @click='handleClickToShowPointTutorial(`point`)')
          IconCcoin(:size='22')
          span 幣是什麼？


    //- 基本狀態
    section(:class='$style[`cc-side-effect-userPost-sec`]')
      div.font-medium(:class='$style[`cc-side-effect-userPost-sec-header`]') 基本狀態
      div(:class='$style[`cc-side-effect-userPost-sec-container`]')
        //- 記錄日期
        div(:class='$style[`cc-side-effect-userPost-sec-list`]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 記錄日期
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            span {{ formConfig.se_date }}
            date-picker(
              v-model='formConfig.se_date'
              placeholder='選擇日期'
              value-type="date" format="YYYY.MM.DD"
              :class='[`date-picker`, $style[formVerify.se_dateError ? `cc-date-error` : ``]]'
              @change='formVerify.se_dateError = false')
              template(v-slot:header="{ emit }")
                button(
                  v-for='(items, index) in datePickerDayShortCut'
                  :title='`選擇${items.text}`' tabindex='0' :aria-label='`選擇${items.text}`'
                  class="mx-btn mx-btn-text" @click="emit(items.onClick())") {{ items.text }}


        //- 體重
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`flex-percent-40`]]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 體重
              span (Kg)
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            Inputer(
              v-model.trim='formConfig.se_weight'
              title='請填寫體重'
              style='width: 100px'
              :class='$style[`cc-input-area`]'
              :resetButton='false'
              :placehold='`60.5`'
              :errorValue='formVerify.se_weightError'
              :errorRegex='formVerify.se_weightRegexError'
              :errorRegexInfo='formVerify.se_weightErrorLog'
              @clearErrorMsg="(value) => {this.formVerify.se_weightError = value[0]; this.formVerify.se_weightRegexError = value[1];}")

        //- 體溫
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`flex-percent-60`]]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 有發燒超過38度?
              span (攝氏)
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            SelectModel(
              v-model='hasFever'
              title='選擇是否發燒超過38度'
              style='width: 70px; margin-right: 7px; margin-bottom: 5px;'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :optionList='[`有`, `沒有`]'
              :defaultValue='`沒有`'
              @clearErrorMsg="(value) => {this.formVerify.se_feverError = value}")

            div(v-if='hasFever === `有`' :class='$style[`cc-side-effect-userPost-sec-subarea`]')
              Inputer(
                v-model.trim='formConfig.se_fever'
                title='請填寫體溫'
                style='width: 120px; margin-bottom: 7px;'
                :class='$style[`cc-input-area`]'
                :resetButton='false'
                :placehold='`範例 36.5`'
                :errorValue='formVerify.se_feverError'
                :errorRegex='formVerify.se_feverRegexError'
                :errorRegexInfo='formVerify.se_feverErrorLog'
                @clearErrorMsg="(value) => {this.formVerify.se_feverError = value[0]; this.formVerify.se_feverRegexError = value[1];}")



        div(:class='$style[`cc-side-effect-userPost-sec-list`]' style='margin: 5px 0 10px;')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 正在接受的治療?
              span (可多選)
          div(:class='[$style[`cc-side-effect-userPost-sec-area`], $style[formVerify.se_now_treatmentError ? `need-value` : ``]]')
            button(
              v-for='(items, index) in cancerTreatmentList'
              :data-value='items'
              tabindex='0' :aria-label='`選擇${items}`'
              :class='$style[`cc-side-effect-userPost-nav-btn`]'
              @click='handleSelectCurrentTreatment') {{ items }}


        //- 生活品質
        div(:class='$style[`cc-side-effect-userPost-sec-list`]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 生活品質
              span (越高越好)
          div(:class='[$style[`cc-side-effect-userPost-sec-area`], $style[formVerify.se_qualitylifeError ? `need-value` : ``]]')
            button.font-medium(v-for='n in 5' tabindex='0' aria-label='選擇生活品質等級' :class='[$style[`cc-side-effect-userPost-value-btn`], $style[formConfig.se_qualitylife === `${n}` ? `cc-selected` : `` ], $style[`value-btn${n}`]]' @click='switchQualityValue(`${n}`)') {{ n }}

        //- 疼痛指數
        div(:class='$style[`cc-side-effect-userPost-sec-list`]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 疼痛指數
              span (越高越痛)
          div(:class='[$style[`cc-side-effect-userPost-sec-area`], $style[formVerify.se_painlevelError ? `need-value` : ``]]')
            button.font-medium(v-for='n in 5' tabindex='0' aria-label='選擇疼痛等級' :class='[$style[`cc-side-effect-userPost-value-btn`], $style[formConfig.se_painlevel === `${n}` ? `cc-selected` : `` ], $style[`value-btn${6 - n}`]]' @click='switchPainValue(`${n}`)') {{ n }}

        //- 心情狀態
        div(:class='$style[`cc-side-effect-userPost-sec-list`]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 心情狀態
              span (越高越好)
          div(:class='[$style[`cc-side-effect-userPost-sec-area`], $style[formVerify.se_emotionError ? `need-value` : ``]]')
            button.font-medium(v-for='n in 5' tabindex='0' aria-label='選擇心情狀態等級' :class='[$style[`cc-side-effect-userPost-value-btn`], $style[formConfig.se_emotion === `${n}` ? `cc-selected` : `` ], $style[`value-btn${n}`]]' @click='switchEmotionValue(`${n}`)') {{ n }}

    //- 一般記錄
    section(:class='$style[`cc-side-effect-userPost-sec`]')
      div.font-medium(:class='$style[`cc-side-effect-userPost-sec-header`]')!= '放化療副作用'
      div(:class='$style[`cc-side-effect-userPost-sec-container`]')
        //- 食慾減少
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`half-fill`]]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 食慾減少
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            SelectModel(
              v-model='formConfig.se_noappetite'
              title='請選擇食慾減少'
              style='width: 150px'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :optionList='[`沒有`, `輕微`, `中等`, `嚴重`]'
              :errorValue='formVerify.se_noappetiteError'
              @clearErrorMsg="(value) => {this.formVerify.se_noappetiteError = value}")

        //- 胃部不適
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`half-fill`]]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 胃部不適
              span (痛/逆流/脹)
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            SelectModel(
              v-model='formConfig.se_upsetstomach'
              title='請選擇胃部不適'
              style='width: 150px'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :optionList='[`沒有`, `輕微`, `中等`, `嚴重`]'
              :errorValue='formVerify.se_upsetstomachError'
              @clearErrorMsg="(value) => {this.formVerify.se_upsetstomachError = value}")

        //- 腹瀉程度
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`half-fill`]]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 腹瀉程度
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            SelectModel(
              v-model='formConfig.se_diarrhea'
              title='請選擇腹瀉程度'
              style='width: 150px'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :optionList='[`沒有`, `輕微`, `中等`, `嚴重`]'
              :errorValue='formVerify.se_diarrheaError'
              @clearErrorMsg="(value) => {this.formVerify.se_diarrheaError = value}")

        //- 便秘程度
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`half-fill`]]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 便秘程度
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            SelectModel(
              v-model='formConfig.se_constipation'
              title='請選擇便秘程度'
              style='width: 150px'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :optionList='[`沒有`, `輕微`, `中等`, `嚴重`]'
              :errorValue='formVerify.se_constipationError'
              @clearErrorMsg="(value) => {this.formVerify.se_constipationError = value}")

        //- 噁心嘔吐
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`half-fill`]]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 噁心嘔吐
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            SelectModel(
              v-model='formConfig.se_nausea'
              title='請選擇噁心嘔吐'
              style='width: 150px'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :optionList='[`沒有`, `輕微`, `中等`, `嚴重`]'
              :errorValue='formVerify.se_nauseaError'
              @clearErrorMsg="(value) => {this.formVerify.se_nauseaError = value}")

        //- 咳嗽程度
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`half-fill`]]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 咳嗽程度
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            SelectModel(
              v-model='formConfig.se_cough'
              title='請選擇咳嗽程度'
              style='width: 150px'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :optionList='[`沒有`, `輕微`, `中等`, `嚴重`]'
              :errorValue='formVerify.se_coughError'
              @clearErrorMsg="(value) => {this.formVerify.se_coughError = value}")

        //- 喘氣程度
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`half-fill`]]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 喘氣程度
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            SelectModel(
              v-model='formConfig.se_pant'
              title='請選擇喘氣程度'
              style='width: 150px'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :optionList='[`沒有`, `輕微`, `中等`, `嚴重`]'
              :errorValue='formVerify.se_pantError'
              @clearErrorMsg="(value) => {this.formVerify.se_pantError = value}")

        //- 感覺疲憊
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`half-fill`]]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 感覺疲憊
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            SelectModel(
              v-model='formConfig.se_exhausted'
              title='請選擇感覺疲憊'
              style='width: 150px'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :optionList='[`沒有`, `輕微`, `中等`, `嚴重`]'
              :errorValue='formVerify.se_exhaustedError'
              @clearErrorMsg="(value) => {this.formVerify.se_exhaustedError = value}")

        //- 憂鬱程度
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`half-fill`]]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 憂鬱程度
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            SelectModel(
              v-model='formConfig.se_melancholia'
              title='請選擇憂鬱程度'
              style='width: 150px'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :optionList='[`沒有`, `輕微`, `中等`, `嚴重`]'
              :errorValue='formVerify.se_melancholiaError'
              @clearErrorMsg="(value) => {this.formVerify.se_melancholiaError = value}")

        //- 失眠程度
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`half-fill`]]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 失眠程度
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            SelectModel(
              v-model='formConfig.se_insomnia'
              title='請選擇失眠程度'
              style='width: 150px'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :optionList='[`沒有`, `輕微`, `中等`, `嚴重`]'
              :errorValue='formVerify.se_insomniaError'
              @clearErrorMsg="(value) => {this.formVerify.se_insomniaError = value}")

        //- 手麻腳麻
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`half-fill`]]')
          div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
            span 化療引起手麻腳麻
          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            SelectModel(
              v-model='formConfig.se_cipn'
              title='請選擇化療引起手麻腳麻'
              style='width: 150px'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :optionList='[`沒有`, `輕微`, `中等`, `嚴重`]'
              :errorValue='formVerify.se_cipnError'
              @clearErrorMsg="(value) => {this.formVerify.se_cipnError = value}")

        //- 放射治療皮膚炎
        div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userPost-sec-title`]')
            span 放射治療皮膚炎程度
              IconInfo(:size='15' :color='`#98a1a1`')

          div(:class='$style[`cc-side-effect-userPost-sec-area`]')
            SelectModel(
              v-model='formConfig.se_dermatitis'
              title='請選擇放射治療皮膚炎'
              style='width: 150px'
              :class='$style[`cc-select-area`]'
              :placehold='`請選擇`'
              :optionList='[`沒有`, `第一級`, `第二級`, `第三級`]')


        div(:class='$style[`cc-side-effect-userPost-sec-list`]')
          div(:class='$style[`cc-side-effect-userPost-sec-tips`]')
            div(:class='$style[`cc-side-effect-userPost-sec-tips-top`]')
              IconInfo(:size='15' :color='`#98a1a1`')
              span 放射治療皮膚炎程度補充說明
            ul(:class='$style[`cc-side-effect-userPost-sec-tips-ul`]')
              li(:class='$style[`cc-side-effect-userPost-sec-tips-li`]') 第一級：輕微發紅，乾脫屑脫皮，毛髮脫落
              li(:class='$style[`cc-side-effect-userPost-sec-tips-li`]') 第二級：明顯發紅，少量濕性脫皮，輕微水腫與疼痛
              li(:class='$style[`cc-side-effect-userPost-sec-tips-li`]') 第三級：嚴重脫皮，大量濕性脫皮，明顯水腫，碰撞出血

        


    //- 重大事件
    section(:class='$style[`cc-side-effect-userPost-sec`]')
      div.font-medium(:class='$style[`cc-side-effect-userPost-sec-header`]') 重大事件(選填)
      div(:class='$style[`cc-side-effect-userPost-sec-container`]')

        div(:class='$style[`cc-side-effect-userPost-sec-block`]')
          header.font-medium(:class='$style[`cc-side-effect-userPost-sec-head`]') 改變的新服用藥物
          div(:class='$style[`cc-side-effect-userPost-sec-list`]')
            div(:class='$style[`cc-side-effect-userPost-sec-title`]')
              span 藥物名稱
                span (中/英文皆可)
            div(:class='$style[`cc-side-effect-userPost-sec-area`]')
              Inputer(
                v-model='formConfig.supple_medicine'
                title='請填寫新服用藥物'
                style='width: 300px;'
                :class='$style[`cc-input-area`]'
                :resetButton='false'
                :placehold='`範例：復乳納 Letrozole`')

        div(:class='$style[`cc-side-effect-userPost-sec-block`]')
          header.font-medium(:class='$style[`cc-side-effect-userPost-sec-head`]') 其他的改變治療
          //- div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`half-fill`]]')
          //-   div(:class='$style[`cc-side-effect-userPost-sec-title`]')
          //-     span!= '新的治療'
          //-   div(:class='$style[`cc-side-effect-userPost-sec-area`]')
          //-     SelectModel(
          //-       v-model='formConfig.change_plan'
          //-       title='請選擇新的治療'
          //-       style='width: 120px;'
          //-       :class='$style[`cc-select-area`]'
          //-       :placehold='`請選擇`'
          //-       :optionList='cancerTreatmentList')


          div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`align-top`]]')
            div(:class='$style[`cc-side-effect-userPost-sec-title`]')
              span 補充說明
                span (打疫苗/中醫)
            div(:class='$style[`cc-side-effect-userPost-sec-area`]')
              TextAreaer(
                v-model='formConfig.supple_explanation'
                title='請填寫補充說明'
                :autoSize='true'
                :class='$style[`cc-input-textarea`]'
                :resetButton='false'
                :placehold='`請填寫...`')



        //- div(:class='$style[`cc-side-effect-userPost-sec-block`]')
        //-   header.font-medium(:class='$style[`cc-side-effect-userPost-sec-head`]')!= '其他補充說明'
        //-   div(:class='$style[`cc-side-effect-userPost-sec-list`]')
        //-     div(:class='$style[`cc-side-effect-userPost-sec-title`]')
        //-       span!= '檢查時間'
        //-         span!= '(年/月)'
        //-     div(:class='$style[`cc-side-effect-userPost-sec-area`]')
        //-       date-picker(
        //-         v-model='formConfig.supple_date'
        //-         placeholder='選擇日期'
        //-         valueType='format'
        //-         format='YYYY.MM.DD'
        //-         :class='`date-picker`')
        //-         template(v-slot:header="{ emit }")
        //-           button(
        //-             v-for='(items, index) in datePickerDayShortCut'
        //-             :title='`選擇${items.text}`' tabindex='0' :aria-label='`選擇${items.text}`'
        //-             class="mx-btn mx-btn-text" @click="emit(items.onClick())") {{ items.text }}

        //-   div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`align-top`]]')
        //-     div(:class='$style[`cc-side-effect-userPost-sec-title`]')
        //-       span!= '補充說明'
        //-         span!= '(打疫苗/跌倒)'
        //-     div(:class='$style[`cc-side-effect-userPost-sec-area`]')
        //-       TextAreaer(
        //-         v-model='formConfig.supple_explanation'
        //-         title='請填寫補充說明'
        //-         :autoSize='true'
        //-         :class='$style[`cc-input-textarea`]'
        //-         :resetButton='false'
        //-         :placehold='`請填寫...`')



        div(:class='$style[`cc-side-effect-userPost-sec-block`]')
          header.font-medium(:class='$style[`cc-side-effect-userPost-sec-head`]') 免疫治療(有接受填寫)
          //- 放射治療皮膚炎
          div(:class='[$style[`cc-side-effect-userPost-sec-list`], $style[`align-top`]]')
            div(:class='$style[`cc-side-effect-userPost-sec-title`]')
              span 副作用產生
            div(:class='$style[`cc-side-effect-userPost-sec-area`]')
              CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`皮搔癢/發疹`' @sendCheckStatus='watchCheckBoxUpdate')
              CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`肌肉痛/關節痛`' @sendCheckStatus='watchCheckBoxUpdate')
              CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`頭痛/頭暈`' @sendCheckStatus='watchCheckBoxUpdate')
              CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`視野模糊`' @sendCheckStatus='watchCheckBoxUpdate')
              CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`胸痛`' @sendCheckStatus='watchCheckBoxUpdate')
              CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`血便/黑便`' @sendCheckStatus='watchCheckBoxUpdate')
              CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`心跳加速/盜汗`' @sendCheckStatus='watchCheckBoxUpdate')
              CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`全身無力/怕冷`' @sendCheckStatus='watchCheckBoxUpdate')
              CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`排尿減少/血尿`' @sendCheckStatus='watchCheckBoxUpdate')
              CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`黃疸/深色尿`' @sendCheckStatus='watchCheckBoxUpdate')
              CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`紅腫/浮腫`' @sendCheckStatus='watchCheckBoxUpdate')
              CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`水泡/口腔潰瘍`' @sendCheckStatus='watchCheckBoxUpdate')


    //- 醫療院所試驗計畫
    section(:class='$style[`cc-side-effect-userPost-sec`]')
      div.font-medium(:class='$style[`cc-side-effect-userPost-sec-header`]') 參加醫療院所臨床試驗(選填)
      div(:class='$style[`cc-side-effect-userPost-sec-container`]')
        div(:class='[$style[`cc-side-effect-userPost-sec-block`], $style[`cmu-plan`]]')
          header.font-medium(:class='$style[`cc-side-effect-userPost-sec-head`]') 選擇計畫做額外填寫
          div(:class='$style[`cc-side-effect-userPost-sec-block-panel`]')
            button(
              title='【頭頸癌患者】額外紀錄'
              tabindex='0' aria-label='【頭頸癌患者】額外紀錄'
              :class='[$style[`cc-side-effect-userPost-cmu-btn`], $style[cmu ? `isActive` : ``]]'
              @click='cmu = !cmu')
              div(:class='$style[`cc-side-effect-userPost-cmu-btn-info`]')
                span.font-medium(:class='$style[`cc-side-effect-userPost-cmu-btn-info-main`]') 【中國醫藥附設醫院 / 新光醫院】頭頸癌記錄
                span(:class='$style[`cc-side-effect-userPost-cmu-btn-info-sub`]') 填寫即代表同意分享紀錄數據做臨床試驗之用途。


          div(v-if='cmu' :class='$style[`cc-side-effect-userPost-sec-block-form`]')
            div(:class='$style[`cc-side-effect-userPost-sec-list`]')
              div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
                span 哪個部位感覺疼痛、痠痛?
              div(:class='$style[`cc-side-effect-userPost-sec-area`]')
                SelectModel(
                  v-model='cmuConfig.pain'
                  title='請選擇疼痛痠痛部位'
                  style='width: 120px;'
                  :class='$style[`cc-select-area`]'
                  :placehold='`請選擇`'
                  :optionList='[`無`, `口腔`, `下顎`, `喉嚨`]'
                  :errorValue='cmuVerify.painError'
                  @clearErrorMsg="(value) => {this.cmuVerify.painError = value}")

            div(v-if='cmuConfig.pain && cmuConfig.pain !== `無`' :class='$style[`cc-side-effect-userPost-sec-list`]')
              div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
                span 承上題，不舒服的程度?
              div(:class='$style[`cc-side-effect-userPost-sec-area`]')
                SelectModel(
                  v-model='cmuConfig.painLevel'
                  title='請選擇不舒服的程度'
                  style='width: 120px;'
                  :class='$style[`cc-select-area`]'
                  :placehold='`請選擇`'
                  :optionList='[`輕微`, `中等`, `嚴重`]'
                  :errorValue='cmuVerify.painLevelError'
                  @clearErrorMsg="(value) => {this.cmuVerify.painLevelError = value}")

            div(:class='$style[`cc-side-effect-userPost-sec-list`]')
              div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
                span 您進食時會有困難嗎? 
              div(:class='$style[`cc-side-effect-userPost-sec-area`]')
                SelectModel(
                  v-model='cmuConfig.eatHard'
                  title='請選擇進食時是否有困難'
                  style='width: 120px;'
                  :class='$style[`cc-select-area`]'
                  :placehold='`請選擇`'
                  :optionList='[`有`, `沒有`]'
                  :errorValue='cmuVerify.eatHardError'
                  @clearErrorMsg="(value) => {this.cmuVerify.eatHardError = value}")

            div(v-if='cmuConfig.eatHard == `有`' :class='$style[`cc-side-effect-userPost-sec-list`]')
              div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
                span 進食哪個步驟覺得困難? 
              div(:class='$style[`cc-side-effect-userPost-sec-area`]')
                SelectModel(
                  v-model='cmuConfig.eatStep'
                  title='請選擇困難的步驟'
                  style='width: 120px;'
                  :class='$style[`cc-select-area`]'
                  :placehold='`請選擇`'
                  :optionList='[`張嘴`, `咀嚼`, `吞嚥`]'
                  :errorValue='cmuVerify.eatStepError'
                  @clearErrorMsg="(value) => {this.cmuVerify.eatStepError = value}")

            div(v-if='cmuConfig.eatHard == `有`' :class='$style[`cc-side-effect-userPost-sec-list`]')
              div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
                span 哪種狀態的食物比較困難?
              div(:class='$style[`cc-side-effect-userPost-sec-area`]')
                SelectModel(
                  v-model='cmuConfig.eatFood'
                  title='請選擇困難的食物狀態'
                  style='width: 120px;'
                  :class='$style[`cc-select-area`]'
                  :placehold='`請選擇`'
                  :optionList='[`固體`, `液體`, `兩者都會`]'
                  :errorValue='cmuVerify.eatFoodError'
                  @clearErrorMsg="(value) => {this.cmuVerify.eatFooError = value}")

            div(:class='$style[`cc-side-effect-userPost-sec-list`]')
              div(:class='[$style[`cc-side-effect-userPost-sec-title`], $style[`need-fill`]]')
                span 是否曾經嗆到?
              div(:class='$style[`cc-side-effect-userPost-sec-area`]')
                SelectModel(
                  v-model='cmuConfig.choke'
                  title='請選擇是否曾經嗆到'
                  style='width: 120px;'
                  :class='$style[`cc-select-area`]'
                  :placehold='`請選擇`'
                  :optionList='[`有`, `沒有`]'
                  :errorValue='cmuVerify.chokeError'
                  @clearErrorMsg="(value) => {this.cmuVerify.chokeError = value}")

            div(:class='$style[`cc-side-effect-userPost-sec-list`]' style='display: block')
              div(:class='$style[`cc-side-effect-userPost-sec-title`]')
                span 請上傳三餐照片
              div(:class='$style[`cc-side-effect-userPost-sec-area`]')
                div(:class='$style[`cc-uploader-content`]')
                  div(v-if='cmuConfig.photoBreakfastSrc' :class='$style[`cc-uploader-area`]')
                    button(
                      tabindex='0'
                      aria-label='移除上傳圖片'
                      :class='$style[`cc-uploader-delete-btn`]' @click='cmuConfig.photoBreakfast = null; cmuConfig.photoBreakfastSrc = ``')
                      IconDelete(:size='16' :color='`#b1b1b1`')
                      span 移除
                    img(:src='cmuConfig.photoBreakfastSrc' width='100%')
                  div(v-else :class='[$style[`cc-uploader-area`], $style[cmuVerify.photoBreakfastError ? `cc-uploader-error` : ``]]')
                    input(
                      type='file'
                      ref='cmu-breakfast'
                      name='breakfast'
                      :class='$style[`cc-uploader-inputer`]'
                      @change='handlePhotoBreakfast')
                    div(:class='$style[`cc-uploader-interface`]')
                      IconUpload(:size='40' :color='`#dcdcdc`')
                      span(v-if='cmuVerify.photoBreakfastError' :class='$style[`cc-uploader-tip-error`]') {{ showBreakfastErrorTips }}
                      span(v-else :class='$style[`cc-uploader-tip`]') 早餐


                  div(v-if='cmuConfig.photoLunchSrc' :class='$style[`cc-uploader-area`]')
                    button(
                      tabindex='0'
                      aria-label='移除上傳圖片'
                      :class='$style[`cc-uploader-delete-btn`]' @click='cmuConfig.photoLunchSrc = null; cmuConfig.photoLunchSrc = ``')
                      IconDelete(:size='16' :color='`#b1b1b1`')
                      span 移除
                    img(:src='cmuConfig.photoLunchSrc' width='100%')
                  div(v-else :class='[$style[`cc-uploader-area`], $style[cmuVerify.photoLunchError ? `cc-uploader-error` : ``]]')
                    input(
                      type='file'
                      ref='cmu-lunch'
                      name='lunch'
                      :class='$style[`cc-uploader-inputer`]'
                      @change='handlePhotoLunch')
                    div(:class='$style[`cc-uploader-interface`]')
                      IconUpload(:size='40' :color='`#dcdcdc`')
                      span(v-if='cmuVerify.photoLunchError' :class='$style[`cc-uploader-tip-error`]') {{ showLunchErrorTips }}
                      span(v-else :class='$style[`cc-uploader-tip`]') 午餐

                  

                  div(v-if='cmuConfig.photoDinnerSrc' :class='$style[`cc-uploader-area`]')
                    button(
                      tabindex='0'
                      aria-label='移除上傳圖片'
                      :class='$style[`cc-uploader-delete-btn`]' @click='cmuConfig.photoDinnerSrc = null; cmuConfig.photoDinnerSrc = ``')
                      IconDelete(:size='16' :color='`#b1b1b1`')
                      span 移除
                    img(:src='cmuConfig.photoDinnerSrc' width='100%')
                  div(v-else :class='[$style[`cc-uploader-area`], $style[cmuVerify.photoDinnerError ? `cc-uploader-error` : ``]]')
                    input(
                      type='file'
                      ref='cmu-dinner'
                      name='dinner'
                      :class='$style[`cc-uploader-inputer`]'
                      @change='handlePhotoDinner')
                    div(:class='$style[`cc-uploader-interface`]')
                      IconUpload(:size='40' :color='`#dcdcdc`')
                      span(v-if='cmuVerify.photoDinnerError' :class='$style[`cc-uploader-tip-error`]') {{ showDinnerErrorTips }}
                      span(v-else :class='$style[`cc-uploader-tip`]') 晚餐
               


    div(:class='$style[`cc-side-effect-userPost-control`]')
      button.btn-normal-extra.bg-normal-theme(
        v-if='blockAxiosClick'
        title='處理中'
        tabindex='0'
        aria-label='處理中'
        disabled
        :class='$style[`cc-side-effect-userPost-control-btn`]') 處理中

      button.btn-normal-extra.bg-normal-theme(
        v-else
        title='確認送出'
        tabindex='0'
        aria-label='確認送出'
        :class='$style[`cc-side-effect-userPost-control-btn`]'
        @click.prevent='handleCheckProgressBeforeCreate') 確認送出


</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
// import { debounce } from 'debounce';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/zh-tw';
import axios from 'axios';
import GlobalEmitter from 'tiny-emitter/instance';

import Inputer from '../common/Input';
import SelectModel from '../common/SelectModel';
import TextAreaer from '../common/TextArea';
import CheckBox2 from '../common/Checkbox2';
import IconInfo from '../../icon/Info';
import IconLoading from '../../icon/Loading';
import IconCcoin from '../../icon/Ccoin';
import IconUpload from '../../icon/Upload';
import IconDelete from '../../icon/Delete';

import {
  postCreateSideEffectRecord,
  postCreateSideEffectEvent,
  postCreateSideEffectCmuRecord,
  // postRecordAnalysis,
} from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: '建立副作用紀錄',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/sideeffect/post',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/sideeffect/post',
      }],
    };
  },

  components: {
    DatePicker,
    Inputer,
    TextAreaer,
    SelectModel,
    CheckBox2,
    IconInfo,
    IconLoading,
    IconCcoin,
    IconUpload,
    IconDelete,
  },

  data() {
    return {
      preloading: false,
      // showLoading: false,
      hasFever: '沒有',
      treatmentSelectIndex: 0,

      formConfig: {
        se_date: new Date(),
        se_weight: '',
        se_fever: '36.5',
        // se_cancertype: '',
        // se_cancertypeSpecial: '',
        se_qualitylife: '',
        se_painlevel: '',
        se_emotion: '',
        se_noappetite: '',
        se_upsetstomach: '',
        se_diarrhea: '',
        se_constipation: '',
        se_nausea: '',
        se_cough: '',
        se_pant: '',
        se_exhausted: '',
        se_melancholia: '',
        se_insomnia: '',
        se_dermatitis: '',
        se_cipn: '',
        se_now_treatment: [],
        se_immunitytherapy: [],
        alert_level: 0,

        // change_date: '',
        // change_plan: '',
        supple_date: '',
        supple_explanation: '',
        supple_medicine: '',

      },

      formVerify: {
        se_dateError: false,

        se_weightError: false,
        se_weightRegexError: false,
        se_weightErrorLog: '限數字',

        se_feverError: false,
        se_feverRegexError: false,
        se_feverErrorLog: '限數字',

        // se_cancertypeError: false,
        // se_cancertypeSpecialError: false,

        se_qualitylifeError: false,
        se_painlevelError: false,
        se_emotionError: false,
        se_noappetiteError: false,
        se_upsetstomachError: false,
        se_diarrheaError: false,
        se_constipationError: false,
        se_nauseaError: false,
        se_coughError: false,
        se_pantError: false,
        se_exhaustedError: false,
        se_melancholiaError: false,
        se_insomniaError: false,
        se_now_treatmentError: false,
        se_cipnError: false,
      },

      cmu: false,
      cmuConfig: {
        pain: '',
        painLevel: '',
        eatHard: '',
        eatStep: '',
        eatFood: '',
        choke: '',
        photoBreakfast: null,
        photoBreakfastSrc: '',
        photoLunch: null,
        photoLunchSrc: '',
        photoDinner: null,
        photoDinnerSrc: '',
      },

      cmuVerify: {
        painError: false,
        painLevelError: false,
        eatHardError: false,
        eatStepError: false,
        eatFoodError: false,
        chokeError: false,
        photoBreakfastError: false,
        photoLunchError: false,
        photoDinnerError: false,
      },

      showBreakfastErrorTips: '',
      showLunchErrorTips: '',
      showDinnerErrorTips: '',
      alertList: [],
      verifyAllPass: true,

      blockAxiosClick: false,
    };
  },

  // created() {
  //   if (this.subscribeVip === 'yes') {
  //     this.initRoomWebsocket();
  //   }
  // },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopRecordAdviseStatus: 'global/POPRECORD_ADVISE_STATUS',
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
      changePopProgressStatus: 'global/POPPROGRESS_STATUS',
      updateUserAnalysisCount: 'user/USER_UPDATE_ANALYSIS_COUNT',
    }),

    handleSelectCurrentTreatment(e) {
      e.preventDefault();

      let target = e.target;
      this.formVerify.se_now_treatmentError = false;
      target.classList.toggle(this.$style['js-toggle']);

      if (target.classList.contains(this.$style['js-toggle'])) {
        this.formConfig.se_now_treatment.push(target.getAttribute('data-value'));
      } else {
        this.treatmentSelectIndex = this.formConfig.se_now_treatment.indexOf(target.getAttribute('data-value'));
        this.formConfig.se_now_treatment.splice(this.treatmentSelectIndex, 1);
      }
    },

    handleClickToShowPointTutorial(feature) {
      this.changePopShowTutorialStatus({
        active: true,
        include: feature,
      });
    },

    switchQualityValue(value) {
      this.formConfig.se_qualitylife = value;
      this.formVerify.se_qualitylifeError = false;
    },

    switchPainValue(value) {
      this.formConfig.se_painlevel = value;
      this.formVerify.se_painlevelError = false;
    },

    switchEmotionValue(value) {
      this.formConfig.se_emotion = value;
      this.formVerify.se_emotionError = false;
    },

    watchCheckBoxUpdate(value, text) {
      if (value === 'checked') {
        this.formConfig.se_immunitytherapy.push(text);
      } else {
        const filterArray = this.formConfig.se_immunitytherapy.filter((e) => e !== text);
        this.formConfig.se_immunitytherapy = filterArray;
      }

      // this.filterConfig.feature = JSON.stringify(this.featureChoose).replace(/\[|]/g, '').replace(/["']/g, '');
      console.log('this.formConfig.se_immunitytherapy', this.formConfig.se_immunitytherapy);
    },

    checkFormsRequirePass() {
      return new Promise((resolve, reject) => {
        this.verifyAllPass = true;
        const numberPattern = new RegExp(/[0-9]$/);
        // const weightPattern = new RegExp(/^[0-9]$/);

        // 驗證記錄日期欄位為空
        if (!this.formConfig.se_date) {
          this.formVerify.se_dateError = true;
          this.verifyAllPass = false;
        }
  
        // 驗證體重欄位為空
        if (this.formConfig.se_weight) {
          if (!this.formConfig.se_weight.match(numberPattern)) {
            this.formVerify.se_weightError = true;
            this.formVerify.se_weightRegexError = true;
            this.verifyAllPass = false;
          }
        } else {
          this.formVerify.se_weightError = true;
          this.verifyAllPass = false;
        }
  
        // 驗證體重欄位為空
        if (this.hasFever === '有') {
          if (this.formConfig.se_fever) {
            if (!this.formConfig.se_fever.match(numberPattern)) {
              this.formVerify.se_feverErrorLog = '限數字';
              this.formVerify.se_feverError = true;
              this.formVerify.se_feverRegexError = true;
              this.verifyAllPass = false;
            } else if (this.formConfig.se_fever <= 38) {
              this.formVerify.se_feverErrorLog = '須超過38度';
              this.formVerify.se_feverError = true;
              this.formVerify.se_feverRegexError = true;
              this.verifyAllPass = false;
            }
          } else {
            this.formVerify.se_feverError = true;
            this.verifyAllPass = false;
          }
        }
  
        // 驗證癌症別欄位為空
        // if (!this.formConfig.se_cancertype) {
        //   this.formVerify.se_cancertypeError = true;
        //   this.verifyAllPass = false;
        // } else if (this.formConfig.se_cancertype === '填寫其他') {
        //   if (!this.formConfig.se_cancertypeSpecial) {
        //     this.formVerify.se_cancertypeSpecialError = true;
        //     this.verifyAllPass = false;
        //   }
        // }
  
        // 驗證癌症期數欄位為空
        if (!this.formConfig.se_qualitylife) {
          this.formVerify.se_qualitylifeError = true;
          this.verifyAllPass = false;
        }
  
        if (!this.formConfig.se_painlevel) {
          this.formVerify.se_painlevelError = true;
          this.verifyAllPass = false;
        }
  
        if (!this.formConfig.se_emotion) {
          this.formVerify.se_emotionError = true;
          this.verifyAllPass = false;
        }
  
        if (!this.formConfig.se_noappetite) {
          this.formVerify.se_noappetiteError = true;
          this.verifyAllPass = false;
        }
  
        if (!this.formConfig.se_upsetstomach) {
          this.formVerify.se_upsetstomachError = true;
          this.verifyAllPass = false;
        }
  
        if (!this.formConfig.se_diarrhea) {
          this.formVerify.se_diarrheaError = true;
          this.verifyAllPass = false;
        }
  
        if (!this.formConfig.se_constipation) {
          this.formVerify.se_constipationError = true;
          this.verifyAllPass = false;
        }
  
        if (!this.formConfig.se_nausea) {
          this.formVerify.se_nauseaError = true;
          this.verifyAllPass = false;
        }
  
        if (!this.formConfig.se_cough) {
          this.formVerify.se_coughError = true;
          this.verifyAllPass = false;
        }
  
        if (!this.formConfig.se_pant) {
          this.formVerify.se_pantError = true;
          this.verifyAllPass = false;
        }
  
        if (!this.formConfig.se_exhausted) {
          this.formVerify.se_exhaustedError = true;
          this.verifyAllPass = false;
        }
  
        if (!this.formConfig.se_melancholia) {
          this.formVerify.se_melancholiaError = true;
          this.verifyAllPass = false;
        }
  
        if (!this.formConfig.se_insomnia) {
          this.formVerify.se_insomniaError = true;
          this.verifyAllPass = false;
        }
  
        if (!this.formConfig.se_cipn) {
          this.formVerify.se_cipnError = true;
          this.verifyAllPass = false;
        }

        if (!this.formConfig.se_now_treatment.length) {
          this.formVerify.se_now_treatmentError = true;
          this.verifyAllPass = false;
        }

        if (this.cmu) {
          if (!this.cmuConfig.pain) {
            this.cmuVerify.painError = true;
            this.verifyAllPass = false;
          }

          if (this.cmuConfig.pain !== '無' && !this.cmuConfig.painLevel) {
            this.cmuVerify.painLevelError = true;
            this.verifyAllPass = false;
          }

          if (!this.cmuConfig.eatHard) {
            this.cmuVerify.eatHardError = true;
            this.verifyAllPass = false;
          }

          if (this.cmuConfig.eatHard === '有' && !this.cmuConfig.eatStep) {
            this.cmuVerify.eatStepError = true;
            this.verifyAllPass = false;
          }

          if (this.cmuConfig.eatHard === '有' && !this.cmuConfig.eatFood) {
            this.cmuVerify.eatFoodError = true;
            this.verifyAllPass = false;
          }

          if (!this.cmuConfig.choke) {
            this.cmuVerify.chokeError = true;
            this.verifyAllPass = false;
          }
        }

        this.verifyAllPass ? resolve() : this.showEmptyEproError();
      })
    },

    showEmptyEproError() {
      this.changePopBoxStatus({
        active: true,
        include: 'warnEmptyEproError',
      });
    },

    checkRecordAlertLevelAndSaveAdvise() {
      console.log('checkRecordAlertLevelAndSaveAdvise');
      this.blockAxiosClick = true;

      return new Promise((resolve) => {
        this.changePopBoxStatus({
          active: true,
          include: 'loading',
        });

        Object.entries(this.formConfig).forEach((item) => {
          if (/^(?:se_emotion)$/.test(item[0]) && Number(item[1]) < 3) {
            this.alertList.push({
              name: item[0],
              value: item[1]
            });
          } else if (/^(?:se_painlevel)$/.test(item[0]) && Number(item[1]) > 3) {
            this.alertList.push({
              name: item[0],
              value: item[1]
            });
          } else if (/^(?:se_dermatitis)$/.test(item[0]) && /^(?:第二級|第三級)$/.test(item[1])) {
            console.log('放射治療皮膚炎程度', item[1]);
            this.alertList.push({
              name: item[0],
              value: item[1]
            });
          } else if (/^(?:se_immunitytherapy)$/.test(item[0]) && item[1].length) {
            this.alertList.push({
              name: item[0],
              value: item[1]
            });
          } else {
            if (/^(?:中等|嚴重)$/.test(item[1])) {
              this.alertList.push({
                name: item[0],
                value: item[1]
              });
            }
          }
          console.log(this.alertList);
        });

        resolve(this.alertList);
      })
    },

    axiosCreateSideEffectRecordStep1() {
      return new Promise((resolve, reject) => {
        const POST_DATA = {
          se_date: moment(this.formConfig.se_date).format('YYYY.MM.DD'),
          se_auth_id: `${this.loginDjangoId}`,
          se_personal_id: `${this.loginProfile.personal_id}`,
          se_weight: `${this.formConfig.se_weight}`,
          se_fever: `${this.formConfig.se_fever}`,
          se_cancertype: this.formConfig.se_cancertype === `填寫其他` ? `${this.formConfig.se_cancertypeSpecial}` : `${this.formConfig.se_cancertype}`,
          se_qualitylife: `${this.formConfig.se_qualitylife}`,
          se_painlevel: `${this.formConfig.se_painlevel}`,
          se_emotion: `${this.formConfig.se_emotion}`,
          se_now_treatment: JSON.stringify(this.formConfig.se_now_treatment).replace(/\[|]/g, '').replace(/["']/g, ''),
  
          se_noappetite: `${this.formConfig.se_noappetite}`,
          se_upsetstomach: `${this.formConfig.se_upsetstomach}`,
          se_diarrhea: `${this.formConfig.se_diarrhea}`,
          se_constipation: `${this.formConfig.se_constipation}`,
          se_nausea: `${this.formConfig.se_nausea}`,
          se_cough: `${this.formConfig.se_cough}`,
          se_pant: `${this.formConfig.se_pant}`,
          se_exhausted: `${this.formConfig.se_exhausted}`,
          se_melancholia: `${this.formConfig.se_melancholia}`,
          se_insomnia: `${this.formConfig.se_insomnia}`,
          se_cipn: `${this.formConfig.se_cipn}`,
          se_dermatitis: `${this.formConfig.se_dermatitis}`,
          se_immunitytherapy: this.formConfig.se_immunitytherapy ? JSON.stringify(this.formConfig.se_immunitytherapy) : '',
          alert_level: this.setAlertLevel,

          room: `0-${this.loginHashCode}-${this.loginDjangoId}`
        };
  
        // const jwtAccess = JSON.parse(this.authJwtToken).a;
        const CONFIG = {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        };
        console.log('POST_DATA', POST_DATA);
  
        postCreateSideEffectRecord('', POST_DATA, CONFIG)
          .then((res) => {
            console.log('建立副作用一般記錄 Success', res);
            this.updateUserAnalysisCount(res.data.analysis_count);
            resolve({
              gr_id: res.data.gr_id,
              analysis: res.data.analysis,
              analysis_count: res.data.analysis_count
            });
          })
          .catch((err) => {
            console.log('建立副作用一般記錄 Error', err.response.data.reason);
            if (err.response.data.reason === 'date exist') {
              this.changePopBoxStatus({
                active: true,
                include: 'warnRecordExist',
              });
            } else if (err.response.data === 'date error') {
              this.changePopBoxStatus({
                active: true,
                include: 'warnDateError',
              });
            } else {
              this.changePopBoxStatus({
                active: true,
                include: 'warnError',
              });
            }

            reject();
          })
      })
    },

    axiosCreateSideEffectRecordStep2(step1Arg) {
      console.log('axiosCreateSideEffectRecordStep2', step1Arg.gr_id)
      return new Promise((resolve, reject) => {
        const POST_EVENT_DATA = {
          gr_id: `${step1Arg.gr_id}`,
          // change_date: this.formConfig.change_date === null ? `` : this.formConfig.change_date,
          // change_plan: this.formConfig.change_plan,
          // supple_date: this.formConfig.supple_date === null ? `` : this.formConfig.supple_date,
          supple_date: moment(this.formConfig.se_date).format('YYYY.MM.DD'),
          supple_explanation: this.formConfig.supple_explanation,
          supple_medicine: this.formConfig.supple_medicine,
        };
  
        // const jwtAccess = JSON.parse(this.authJwtToken).a;
        const CONFIG1 = {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        };

        const CONFIG2 = {
          headers: {
            'content-Type': 'multipart/form-data',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        };
  
        if (this.cmu) {
          const formData = new FormData();
          // const fileBreakfastType = this.cmuConfig.photoBreakfast.type === 'image/jpeg' ? 'jpg' : 'png';
          // const fileLunchType = this.cmuConfig.photoLunch.type === 'image/jpeg' ? 'jpg' : 'png';
          // const fileDinnerType = this.cmuConfig.photoDinner.type === 'image/jpeg' ? 'jpg' : 'png';

          formData.append('gr_id', step1Arg.gr_id);
          formData.append('pain', this.cmuConfig.pain);
          formData.append('pain_level', this.cmuConfig.painLevel);
          formData.append('eat_hard', this.cmuConfig.eatHard);
          formData.append('eat_step', this.cmuConfig.eatStep);
          formData.append('eat_food', this.cmuConfig.eatFood);
          formData.append('choke', this.cmuConfig.choke);

          if (this.cmuConfig.photoBreakfast) {
            const fileType = this.cmuConfig.photoBreakfast.type === 'image/jpeg' ? 'jpg' : 'png';
            formData.append('photo_breakfast', this.cmuConfig.photoBreakfast, `u${this.loginDjangoId}_breakfast_r${step1Arg.gr_id}.${fileType}`);
          }

          if (this.cmuConfig.photoLunch) {
            const fileType = this.cmuConfig.photoLunch.type === 'image/jpeg' ? 'jpg' : 'png';
            formData.append('photo_lunch', this.cmuConfig.photoLunch, `u${this.loginDjangoId}_lunch_r${step1Arg.gr_id}.${fileType}`);
          }

          if (this.cmuConfig.photoDinner) {
            const fileType = this.cmuConfig.photoDinner.type === 'image/jpeg' ? 'jpg' : 'png';
            formData.append('photo_dinner', this.cmuConfig.photoDinner, `u${this.loginDjangoId}_dinner_r${step1Arg.gr_id}.${fileType}`)
          }

          axios.all([
            postCreateSideEffectEvent('', POST_EVENT_DATA, CONFIG1),
            postCreateSideEffectCmuRecord('', formData, CONFIG2),
          ])
            .then(axios.spread((event, cmu) => {
              this.handleUserAddCoin(this.loginDjangoId, 'sideeffect-post', `+${this.subscribeVip === 'yes' ? this.COIN_VIP : this.COIN_FREE}`);
              this.changePopBoxStatus({
                active: false,
                include: '',
              });

              if (event && cmu) {
                resolve();
              }
            }))
            .catch((error) => {
              console.log('建立副作用重大事件&臨床試驗計畫 Error: ', error.response);
              this.changePopBoxStatus({
                active: true,
                include: 'warnError',
              });
              reject();
            });
        } else {
          postCreateSideEffectEvent('', POST_EVENT_DATA, CONFIG1)
            .then((res) => {
              console.log('建立副作用重大事件 Success', res);
        
              this.handleUserAddCoin(this.loginDjangoId, 'sideeffect-post', `+${this.subscribeVip === 'yes' ? this.COIN_VIP : this.COIN_FREE}`);
    
              this.changePopBoxStatus({
                active: false,
                include: '',
              });
              resolve();
            })
            .catch((err) => {
              console.log('建立副作用重大事件 Error', err);
              this.changePopBoxStatus({
                active: true,
                include: 'warnError',
              });
              reject();
            })
        }
      })
    },

    sendSuccessCallback(step1Data) {
      this.blockAxiosClick = false;

      this.$router.replace({
        name: 'effect-record',
      }).catch(() => true);

      console.log('step1Data', step1Data)

      if (step1Data.analysis) {
        if (step1Data.analysis === 'prediction') {
          GlobalEmitter.emit('start-prediction', {
            analysis: true,
          });

          this.changePopProgressStatus({
            active: true,
            feature: 'prediction',
          });
        } else {
          this.changePopProgressStatus({
            active: true,
            feature: 'analysis',
          });
        }
      }
    },

    handlePhotoBreakfast() {
      this.cmuVerify.photoBreakfastError = false;

      const uploadProcess = new Promise((resolve) => {
        const photoFile = this.$refs['cmu-breakfast'].files;
        // this.showUploadErrorMsg = false;
        // this.cmuConfig.photoBreakfast = photoFile;
        return resolve(photoFile);
      });

      uploadProcess.then((value) => {
        const file = value[0];
        if (file.type === '' || file.type === 'image/jpeg' || file.type === 'image/png') {
          const vm = this;
          const _URL = window.URL || window.webkitURL;
          const img = new Image();
          img.src = _URL.createObjectURL(file);

          img.onload = function () {
            if (file.size > (6000 * 1024)) {
              vm.cmuVerify.photoBreakfastError = true;
              vm.showBreakfastErrorTips = '檔案過大，需小於5mb';
            } else {
              vm.cmuConfig.photoBreakfast = file;
              vm.cmuConfig.photoBreakfastSrc = img.src;
            }
          };
        } else {
          this.cmuVerify.photoBreakfastError = true;
          this.showBreakfastErrorTips = '僅支援圖片格式';
        }
      })
    },

    handlePhotoLunch() {
      this.cmuVerify.photoLunchError = false;

      const uploadProcess = new Promise((resolve) => {
        const photoFile = this.$refs['cmu-lunch'].files;
        // this.showUploadErrorMsg = false;
        // this.cmuConfig.photoLunch = photoFile;
        return resolve(photoFile);
      });

      uploadProcess.then((value) => {
        const file = value[0];
        if (file.type === '' || file.type === 'image/jpeg' || file.type === 'image/png') {
          const vm = this;
          const _URL = window.URL || window.webkitURL;
          const img = new Image();
          img.src = _URL.createObjectURL(file);
          img.onload = function () {
            if (file.size > (6000 * 1024)) {
              vm.cmuVerify.photoLunchError = true;
              vm.showLunchErrorTips = '檔案過大，需小於5mb';
            } else {
              vm.cmuConfig.photoLunch = file;
              vm.cmuConfig.photoLunchSrc = img.src;
            }
          };
        } else {
          this.cmuVerify.photoLunchError = true;
          this.showLunchErrorTips = '僅支援圖片格式';
        }
      })
    },

    handlePhotoDinner() {
      this.cmuVerify.photoDinnerError = false;

      const uploadProcess = new Promise((resolve) => {
        const photoFile = this.$refs['cmu-dinner'].files;
        // this.showUploadErrorMsg = false;
        // this.cmuConfig.photoDinner = photoFile;
        return resolve(photoFile);
      });

      uploadProcess.then((value) => {
        const file = value[0];
        if (file.type === '' || file.type === 'image/jpeg' || file.type === 'image/png') {
          const vm = this;
          const _URL = window.URL || window.webkitURL;
          const img = new Image();
          img.src = _URL.createObjectURL(file);
          img.onload = function () {
            if (file.size > (6000 * 1024)) {
              vm.cmuVerify.photoDinnerError = true;
              vm.showDinnerErrorTips = '檔案過大，需小於5mb';
            } else {
              vm.cmuConfig.photoDinner = file;
              vm.cmuConfig.photoDinnerSrc = img.src;
            }
          };
        } else {
          this.cmuVerify.photoDinnerError = true;
          this.showDinnerErrorTips = '僅支援圖片格式';
        }
      })
    },

    async handleCheckProgressBeforeCreate() {
      try {
        await this.checkFormsRequirePass();
        await this.checkRecordAlertLevelAndSaveAdvise();
        let step1 = await this.axiosCreateSideEffectRecordStep1();
        await this.axiosCreateSideEffectRecordStep2(step1);
        await this.sendSuccessCallback(step1)

      } catch (err) {
        this.blockAxiosClick = false;
      }
    },

    // async handleCheckProgressBeforeCreate() {
    //   try {

    //     await this.checkFormsRequirePass();
    //     await this.checkRecordAlertLevelAndSaveAdvise();
    //     let step1 = await this.axiosCreateSideEffectRecordStep1();
    //     await this.axiosCreateSideEffectRecordStep2(step1);
    //     await this.sendSuccessCallback(step1)

    //   } catch (err) {
    //     this.blockAxiosClick = false;
    //   }
    // },

    // debounceSendNewSideEffectRecord: debounce(async function(e) {
    //   this.handleCheckProgressBeforeCreate();
    // }, 300),

  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      // loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      loginHashCode: 'user/exportUserHashCode',
      // stateFlowBarFixed: 'global/exportFlowBarFixed',
      subscribeVip: 'user/exportUserSubscribeVip',
      authJwtToken: 'user/exportUserJwtToken',
    }),

    setAlertLevel() {
      const alertLen = this.alertList.length;
      let newLevel = 0;
      if (alertLen > 1 && alertLen < 4) {
        newLevel = 1;
      } else if (alertLen >= 4) {
        newLevel = 2;
      }
      return newLevel;
    },

    eatHard() {
      if (this.cmuConfig.eatHard === '沒有') {
        this.cmuConfig.eatStep = '';
        this.cmuConfig.eatFood = '';
      }
      return this.cmuConfig.eatHard;
    },

    pain() {
      if (this.cmuConfig.pain === '無') {
        this.cmuConfig.painLevel = '';
      }
      return this.cmuConfig.pain;
    }
  },

  watch: {
    hasFever(val) {
      if (val === '沒有') {
        this.formConfig.se_fever = '36.5';
        this.formVerify.se_feverError = false;
      } else {
        this.formConfig.se_fever = '';
        this.formVerify.se_feverError = false;
      }
      console.log('hasFever', this.formConfig.se_fever, this.formVerify.se_feverError);
    },
  }
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectNewPost.scss';
</style>
